import React from 'react';
import Select from '../../../components/ui/Select';
import Input from '../../../components/ui/Input';
import Button from '../../../components/ui/Button';

const FilterControls = ({ filters, onFilterChange, onReset, onCreateProject }) => {
  const countryOptions = [
    { value: 'all', label: 'Todos los países' },
    { value: 'colombia', label: 'Colombia' },
    { value: 'peru', label: 'Perú' },
    { value: 'brasil', label: 'Brasil' },
    { value: 'ecuador', label: 'Ecuador' },
    { value: 'bolivia', label: 'Bolivia' },
    { value: 'chile', label: 'Chile' },
    { value: 'argentina', label: 'Argentina' }
  ];

  const projectTypeOptions = [
    { value: 'all', label: 'Todos los tipos' },
    { value: 'A/R', label: 'A/R - Aforestación/Reforestación' },
    { value: 'IFM', label: 'IFM - Manejo Forestal Mejorado' },
    { value: 'REDD+', label: 'REDD+ - Reducción de Deforestación' },
    { value: 'SOC', label: 'SOC - Carbono Orgánico del Suelo' },
    { value: 'Ganadería Regenerativa', label: 'Ganadería Regenerativa' }
  ];

  const statusOptions = [
    { value: 'all', label: 'Todos los estados' },
    { value: 'Validado', label: 'Validado' },
    { value: 'En Verificación', label: 'En Verificación' },
    { value: 'En Desarrollo', label: 'En Desarrollo' },
    { value: 'Pendiente', label: 'Pendiente' }
  ];

  const standardOptions = [
    { value: 'all', label: 'Todos los estándares' },
    { value: 'Verra', label: 'Verra' },
    { value: 'Gold Standard', label: 'Gold Standard' }
  ];

  return (
    <div className="space-y-4 md:space-y-0">
      <div className="flex flex-col md:flex-row items-start md:items-center justify-between gap-4">
        <div className="w-full md:w-auto">
          <Input
            type="search"
            placeholder="Buscar proyectos..."
            value={filters?.search}
            onChange={(e) => onFilterChange('search', e?.target?.value)}
            className="w-full md:w-80"
          />
        </div>
        <div className="flex items-center gap-2 w-full md:w-auto">
          <Button
            variant="outline"
            size="default"
            onClick={onReset}
            iconName="RotateCcw"
            iconPosition="left"
            className="flex-1 md:flex-initial"
          >
            Restablecer
          </Button>
          <Button
            variant="default"
            size="default"
            onClick={onCreateProject}
            iconName="Plus"
            iconPosition="left"
            className="flex-1 md:flex-initial"
          >
            Nuevo Proyecto
          </Button>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        <Select
          label="País"
          options={countryOptions}
          value={filters?.country}
          onChange={(value) => onFilterChange('country', value)}
          searchable
        />
        <Select
          label="Tipo de Proyecto"
          options={projectTypeOptions}
          value={filters?.projectType}
          onChange={(value) => onFilterChange('projectType', value)}
          searchable
        />
        <Select
          label="Estado"
          options={statusOptions}
          value={filters?.status}
          onChange={(value) => onFilterChange('status', value)}
        />
        <Select
          label="Estándar"
          options={standardOptions}
          value={filters?.standard}
          onChange={(value) => onFilterChange('standard', value)}
        />
      </div>
    </div>
  );
};

export default FilterControls;